import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DigitalLibraryService } from 'app/infrastructure/services/digitalLibrary.service';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';

@Component({
    templateUrl: 'digital-library-progress.component.html'
})
export class DigitalLibraryProgressComponent implements OnInit, OnDestroy {

    progress = 0;
    systemCode: string;
    businessCode: string;
    transactionId: number;
    time = null;

    constructor(
        private activeModal: NgbActiveModal,
        private digitalLibraryService: DigitalLibraryService,
        private alertService: AlertService
    ) { }

    ngOnInit() {
        this.time = setInterval(() => {
            this.digitalLibraryService.getImportProgress(
                this.systemCode, this.businessCode, this.transactionId
            ).subscribe(response => {
                let finish = false;

                if (response.processed !== null) {
                    this.progress = response.processed;
                }

                if (response.successMessage !== null) {
                    this.alertService.showGrowl({
                        type: GrowlType.SUCCESS,
                        body: response.successMessage
                    });

                    finish = true;
                }

                if (response.errorMessage !== null) {
                    this.alertService.showGrowl({
                        type: GrowlType.DANGER,
                        body: response.errorMessage
                    });

                    finish = true;
                }

                if (finish) {
                    this.activeModal.close();
                }
            });
        }, 5000);
    }

    ngOnDestroy() {
        clearInterval(this.time);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/digital-library/progress/digital-library-progress.component.ts